
import React from 'react';
import '../assets/style/NoDataStyle.scss';
import noData from '../assets/images/No-Data.svg';

const NoData: React.FC = () => {
  return (
    <div className="noData">
      <img
        src={noData}
        alt="No Data Available"
        className="icon"
      />

    </div>
  );
};

export default NoData;
